import "./index.css";

/** The tints, by the colors people already have (role colors, alerts). */
export type PillColor =
  | "green"
  | "blue"
  | "gold"
  | "orange"
  | "purple"
  | "red"
  | "gray";

/**
 * A person's small soft pill (or a label's, such as "+2 more"): a light
 * tint of their color, a thin border and small text. A name too long for
 * the space ends in "…", with the full name on hover. With onClick it is a
 * button (to open the person's page, say).
 */
export default function PersonPill({
  label,
  color = "gray",
  title = label,
  onClick,
}: {
  label: string;
  color?: PillColor;
  /** Hover text; the label by default. */
  title?: string;
  onClick?: () => void;
}) {
  const className = `person-pill person-pill--${color}`;
  return onClick ? (
    <button
      type="button"
      className={`${className} person-pill--button`}
      title={title}
      onClick={onClick}
    >
      {label}
    </button>
  ) : (
    <span className={className} title={title}>
      {label}
    </span>
  );
}
